import React from "react";
import { StyledList, StyledListItem, ListLink, ExternalLink } from "./style";

const isExternalLink = (to = "") =>
  /^(https?:\/\/|mailto:)/i.test(to);

const LinkedList = ({ items }) => {
  return (
    <StyledList>
      {items.map((item, index) => (
        <StyledListItem key={index}>
          {isExternalLink(item.to) ? (
            <ExternalLink
              href={item.to}
              target={item.to.startsWith("http") ? "_blank" : undefined}
              rel={item.to.startsWith("http") ? "noreferrer" : undefined}
            >
              {item.label}
            </ExternalLink>
          ) : (
            <ListLink to={item.to}>{item.label}</ListLink>
          )}
        </StyledListItem>
      ))}
    </StyledList>
  );
};

export default LinkedList;
